export const RECEPTIONS_ATTENDANCE_FLOWS = [
	{
		id: 1,
		key: 'EMERGENCY',
		label: 'Emergência',
		icon: 'fa-calendar-exclamation',
		highlightTypes: ['EMERGENCY'],
	},
	{
		id: 2,
		key: 'SCHEDULING',
		label: 'Agendamento',
		icon: 'fa-calendar-day',
		highlightTypes: ['SCHEDULING'],
	},
	{
		id: 3,
		key: 'CONFIRMATION',
		label: 'Confirmação',
		icon: 'fa-check-double',

		highlightTypes: ['SCHEDULED_APPOINTMENT'],
	},
	{
		id: 4,
		key: 'ATTENDING',
		label: 'Atendimento',
		icon: 'fa-calendar-exclamation',
		highlightTypes: ['URGENT_APPOINTMENT'],
	},
	{
		id: 5,
		key: 'FIT',
		label: 'Encaixe',
		icon: 'fa-puzzle-piece',
		// highlightTypes: ['FIT'],
	},
	{
		id: 6,
		key: 'SCHEDULING_SEARCH',
		label: 'Pesq. Agend.',
		icon: 'fa-search',
		// highlightTypes: ['SCHEDULING_SEARCH'],
	},
	{
		id: 7,
		key: 'EXAM_RESULTS',
		label: 'Resultados',
		icon: 'fa-file-search',
		highlightTypes: ['EXAM_RESULTS'],
	},
	{
		id: 8,
		key: 'INFORMATION',
		label: 'Informações',
		icon: 'fa-circle-exclamation',
		// highlightTypes: ['INFORMATION'],
	},
]
